import React, { createContext, useContext, useRef, useState, useCallback } from "react";
import { API, requestTTS } from "../lib/api";

const AudioCtx = createContext(null);
export const useAudio = () => useContext(AudioCtx);

export function AudioProvider({ children }) {
  const audioRef = useRef(typeof Audio !== "undefined" ? new Audio() : null);
  const [speaking, setSpeaking] = useState(false);
  const [loadingKey, setLoadingKey] = useState(null);
  const lastRef = useRef({ text: null, speed: 1.0 });

  const stop = useCallback(() => {
    const a = audioRef.current;
    if (a) {
      a.pause();
      a.currentTime = 0;
    }
    setSpeaking(false);
  }, []);

  const speak = useCallback(async (text, speed = 1.0, tag = "default") => {
    if (!text || !text.trim()) return;
    const a = audioRef.current;
    if (!a) return;
    try {
      stop();
      setLoadingKey(tag);
      lastRef.current = { text, speed };
      const { url } = await requestTTS(text, speed);
      a.src = `${API.replace(/\/api$/, "")}${url}`;
      a.onended = () => setSpeaking(false);
      a.onerror = () => setSpeaking(false);
      await a.play();
      setSpeaking(true);
    } catch (e) {
      console.error("speak error", e);
      setSpeaking(false);
    } finally {
      setLoadingKey(null);
    }
  }, [stop]);

  const repeat = useCallback(() => {
    const { text, speed } = lastRef.current;
    if (text) speak(text, speed, "repeat");
  }, [speak]);

  return (
    <AudioCtx.Provider value={{ speak, stop, repeat, speaking, loadingKey }}>
      {children}
    </AudioCtx.Provider>
  );
}
